import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Utensils } from "lucide-react";

export const Nav = ({ onSignUp, c }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#FBF7F0]/85 backdrop-blur-xl border-b border-[#8E1226]/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className={`flex items-center gap-3 transition-colors ${
            scrolled ? "text-[#8E1226]" : "text-[#FBF7F0]"
          }`}
        >
          {c?.logo_image ? (
            <img
              src={c.logo_image}
              alt="Meals on Wheels Tralee logo"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full object-cover ring-1 ring-white/40 bg-white"
            />
          ) : (
            <Utensils className={`w-5 h-5 ${scrolled ? "text-[#8E1226]" : "text-[#FBF7F0]"}`} strokeWidth={1.6} />
          )}
          <span className="text-sm md:text-[15px] font-medium tracking-tight leading-tight">
            {c?.brand_name_1 || "Meals on Wheels"}{" "}
            <span className="opacity-60">{c?.brand_name_2 || "Tralee"}</span>
          </span>
        </Link>
        <div className="flex items-center gap-5 md:gap-7">
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className={`hidden sm:inline text-xs uppercase tracking-[0.2em] transition-opacity hover:opacity-60 ${
              scrolled ? "text-[#8E1226]" : "text-[#FBF7F0]/80"
            }`}
          >
            Admin
          </Link>
          <button
            data-testid="nav-signup-btn"
            onClick={onSignUp}
            className="rounded-full bg-[#FBF7F0] text-[#8E1226] text-base md:text-lg px-7 md:px-8 py-3.5 font-bold tracking-wide transition-transform duration-300 hover:scale-[1.04] hover:bg-white"
          >
            Volunteer
          </button>
        </div>
      </nav>
    </motion.header>
  );
};
